import {
  generateInvoicePDF,
  generateReceiptPDF,
  generateEstimatePDF,
  type ReceiptData,
} from "@/utils/pdfGenerator";
import {
  DEFAULT_PAYMENT_REQUEST_TEMPLATE,
  DEFAULT_PAYMENT_RECEIVED_TEMPLATE,
  DEFAULT_ESTIMATE_TEMPLATE,
  type PaymentSettings,
} from "@/hooks/usePaymentSettings";

export type DocumentType = "invoice" | "receipt" | "estimate";

export interface DocumentMeta {
  label: string;
  subjectPrefix: string;
  status: "pending" | "paid";
  paymentType: string;
  provider: string;
  smsLinkLabel: string;
  template: (settings: PaymentSettings) => string;
  generatePdf: (data: ReceiptData) => Promise<string>;
}

export const getDocumentMeta = (docType: DocumentType): DocumentMeta => {
  switch (docType) {
    case "receipt":
      return {
        label: "Receipt",
        subjectPrefix: "Payment Receipt",
        status: "paid",
        paymentType: "cash",
        provider: "cash",
        smsLinkLabel: "Receipt",
        template: (s) => s.paymentReceivedTemplate || DEFAULT_PAYMENT_RECEIVED_TEMPLATE,
        generatePdf: (d) => generateReceiptPDF(d),
      };
    case "estimate":
      return {
        label: "Estimate",
        subjectPrefix: "Estimate",
        status: "pending",
        paymentType: "estimate",
        provider: "estimate",
        smsLinkLabel: "Estimate",
        template: (s) => s.estimateTemplate || DEFAULT_ESTIMATE_TEMPLATE,
        generatePdf: (d) => generateEstimatePDF(d),
      };
    case "invoice":
    default:
      return {
        label: "Invoice",
        subjectPrefix: "Invoice",
        status: "pending",
        paymentType: "bank_transfer",
        provider: "bank_transfer",
        smsLinkLabel: "Invoice",
        template: (s) => s.paymentRequestTemplate || DEFAULT_PAYMENT_REQUEST_TEMPLATE,
        generatePdf: (d) => generateInvoicePDF(d),
      };
  }
};
